import { ComposeViewState } from 'owa-mail-compose-store';
import getRecipientsCount from './getRecipientsCount';

export default function isThereOnlyOneToRecipient(composeViewState: ComposeViewState): boolean {
    return (
        getRecipientsCount(composeViewState.toRecipientWell) === 1 &&
        getRecipientsCount(composeViewState.ccRecipientWell) === 0 &&
        getRecipientsCount(composeViewState.bccRecipientWell) === 0
    );
}
